/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Browser_Extensions_Ux_Desc2Inputs */

const en_svc_browser_extensions_ux_desc2 = /** @type {(inputs: Svc_Browser_Extensions_Ux_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A real UI for your extension, popup, options, and onboarding in React, not bare HTML.`)
};

const ar_svc_browser_extensions_ux_desc2 = /** @type {(inputs: Svc_Browser_Extensions_Ux_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`واجهة حقيقية لإضافتك, منبثقة وخيارات وتعريف بالمنتج في React لا HTML عارية.`)
};

const bn_svc_browser_extensions_ux_desc2 = /** @type {(inputs: Svc_Browser_Extensions_Ux_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার এক্সটেনশনের জন্য আসল UI, পপআপ, অপশন ও অনবোর্ডিং React-এ, বেয়ার HTML নয়।`)
};

const de_svc_browser_extensions_ux_desc2 = /** @type {(inputs: Svc_Browser_Extensions_Ux_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine echte Benutzeroberfläche für Ihre Erweiterung, Ihr Popup, Ihre Optionen und Ihr Onboarding in React, kein bloßes HTML.`)
};

const es_svc_browser_extensions_ux_desc2 = /** @type {(inputs: Svc_Browser_Extensions_Ux_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una UI real para su extensión, popup, opciones y onboarding en React, no HTML pelado.`)
};

const fr_svc_browser_extensions_ux_desc2 = /** @type {(inputs: Svc_Browser_Extensions_Ux_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une véritable interface utilisateur pour votre extension, votre popup, vos options et votre intégration dans React, pas du simple HTML.`)
};

const pt_svc_browser_extensions_ux_desc2 = /** @type {(inputs: Svc_Browser_Extensions_Ux_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma UI real para sua extensão, popup, opções e onboarding em React, não HTML pelado.`)
};

const zh_svc_browser_extensions_ux_desc2 = /** @type {(inputs: Svc_Browser_Extensions_Ux_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`给插件做真正的 UI：弹窗、选项页和新手引导都用 React 写，而不是裸写 HTML。`)
};

const tr_svc_browser_extensions_ux_desc2 = /** @type {(inputs: Svc_Browser_Extensions_Ux_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzantınız için gerçek bir arayüz, açılır pencere, seçenekler ve React'te onboarding'iniz, çıplak HTML değil.`)
};

const ru_svc_browser_extensions_ux_desc2 = /** @type {(inputs: Svc_Browser_Extensions_Ux_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настоящий UI для вашего расширения: попап, опции и онбординг на React, а не голый HTML.`)
};

const pl_svc_browser_extensions_ux_desc2 = /** @type {(inputs: Svc_Browser_Extensions_Ux_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prawdziwy interfejs twojego rozszerzenia, popup, opcje i onboarding w Reakcie, nie goły HTML.`)
};

/**
* | output |
* | --- |
* | "A real UI for your extension, popup, options, and onboarding in React, not bare HTML." |
*
* @param {Svc_Browser_Extensions_Ux_Desc2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_browser_extensions_ux_desc2 = /** @type {((inputs?: Svc_Browser_Extensions_Ux_Desc2Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Browser_Extensions_Ux_Desc2Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_browser_extensions_ux_desc2(inputs)
	if (locale === "bn") return bn_svc_browser_extensions_ux_desc2(inputs)
	if (locale === "de") return de_svc_browser_extensions_ux_desc2(inputs)
	if (locale === "es") return es_svc_browser_extensions_ux_desc2(inputs)
	if (locale === "fr") return fr_svc_browser_extensions_ux_desc2(inputs)
	if (locale === "pt") return pt_svc_browser_extensions_ux_desc2(inputs)
	if (locale === "zh") return zh_svc_browser_extensions_ux_desc2(inputs)
	if (locale === "tr") return tr_svc_browser_extensions_ux_desc2(inputs)
	if (locale === "ru") return ru_svc_browser_extensions_ux_desc2(inputs)
	if (locale === "pl") return pl_svc_browser_extensions_ux_desc2(inputs)
	return en_svc_browser_extensions_ux_desc2(inputs)
});
export { svc_browser_extensions_ux_desc2 as "svc_browser-extensions_UX_desc" }